import { Injectable } from '@angular/core';
import { EnvironmentService, ServerRequestInterceptorService } from '@technocom/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Role } from '@app/shared/models/user/role';
import { HrefUtils } from '@technocom/common/http';
import { HrefService } from '@technocom/common';
import { SecurityService } from '@technocom/auth';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class ApiRequestInterceptorService extends ServerRequestInterceptorService {
  constructor(
    href: HrefService,
    protected env: EnvironmentService,
    protected securityService: SecurityService,
    private localize: TranslocoService,
    private envService: EnvironmentService,
    protected http: HttpClient,
  ) {
    super(href, env);
  }

  // т.к. на сервисе нету общего пути (типа /api.... и дальше контролы), то перезаписываем условие.
  matches(request: HttpRequest<any>): boolean {
    return !request.url.startsWith('http');
  }

  reroute(request: HttpRequest<any>): string {
    const requestUrl = request.url;
    // 'operation/course' - реестр курсов Лектора. Без него роль 6 считалась бы
    // публичной (см. rerouteRoot ниже) и адрес собирался бы как
    // /migrants/public/operation/course. Строка полная, а не 'course', чтобы
    // не зацепить /person/course - мобильные курсы мигранта.
    const whiteListUrl = ['authentification', 'registration', 'dictionary', 'login', 'person', 'operation/course'];
    for (const record of whiteListUrl) {
      if (request.url.includes(record)) return super.reroute(request);
    }

    const rerouteRoot = this.securityService.canUserAccess([Role.OPR, Role.DATA_ADM]) ? null : 'public';
    return rerouteRoot
      ? HrefUtils.build([this.envService.api.root, HrefUtils.normalize(requestUrl, rerouteRoot)])
      : super.reroute(request);
  }

  protected extend(request: HttpRequest<any>): HttpRequest<any> {
    if (!this.securityService.canUserAccess([Role.OPR, Role.DATA_ADM])) {
      request = request.clone({
        params: request.params.append('lang', this.localize.getActiveLang().toLocaleUpperCase()),
        withCredentials: true,
      });
    }

    return super.extend(request);
  }
}
